export default {
      id: "arrow-right-alt-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#arrow-right-alt-usage",
      toString: function () {
        return this.url;
      }
    }